import { Component, OnInit, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../../service/main/auth.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
    @Input() language: string;
    @Output() onLanguageChanged: EventEmitter<string> = new EventEmitter();

    startDate: any;
    endDate: any;
    fixed = false;
    user: any;
    constructor(
        private authService: AuthService,
    ) {

    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        const dist = $(document).scrollTop();
        if (dist > 70) {
            this.fixed = true;
        } else if (this.fixed && dist < 70) {
            this.fixed = false;
        }
    }

    ngOnInit() {
        this.user = this.authService.loadUserData();
    }

    checkLoginRole(roles: string[]) {
        if(roles.indexOf(this.user.loginRole) >= 0) {
            return true;
        } else {
            return false;
        }
        // if (this.user.loginRole === this.settingsService.LOGIN_ROLE(Enums.eRole.Administrator)) {
        //     return true;
        // } else {
        //     return false;
        // }
    }

    checkUserCompany() {
        if (this.user.company != null) {
            return true;
        } else {
            return false;
        }
    }

    checkUserPublicInstitution() {
        if (this.user.publicInstitution != null) {
            return true;
        } else {
            return false;
        }
    }

    changeLanguage(language: string) {
        if (language === this.language) {
            return;
        }

        this.onLanguageChanged.emit(language);
    }

}
